// @ts-strict-ignore
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { ProjectVO } from '../model/vo/project.vo';
import { OBJRepresentationDataVO, RepresentationVO } from '@shared/vo/representation.vo';
import { StringValueInLocalesVO } from '../components/article/model/vo/property.vo';
import { ProjectUtils } from '../components/project/util/project-utils';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { GlobalContainer } from '@3d-scene/model3d/global-container';
import { ProjectModel } from '../model/project.model';
import { SelectionModelService } from '../components/article/service/selection-model.service';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class RepresentationService {

  constructor(private projectModel: ProjectModel,
              private selectionModelService: SelectionModelService,
              private articleContainerUtils: ArticleContainerUtils,
              private globalContainer: GlobalContainer) {
  }

  public update(): void {
    const currentProject: ProjectVO = this.projectModel.currentProject;
    if (!currentProject) {
      return;
    }
    currentProject.representations = [];
    ArticleContainerUtils.updateProjectWithGeometricData(currentProject, this.globalContainer);
  }

  public scheduleUpdateForReportGeneration(): Observable<null> {
    const currentProject: ProjectVO = this.projectModel.currentProject;
    if (!currentProject) {
      return of(null);
    }
    if (!this.projectModel.view3dRepresentationForSavePurposes) {
      this.selectionModelService.removeAllSelections();
      const subject: Subject<any> = new Subject<any>();
      this.articleContainerUtils.scheduleCreateObjRepresentationData(
        (objRepresentationData: OBJRepresentationDataVO): void => {
          const representationUrl: StringValueInLocalesVO = ProjectUtils.findFirstView3DRepresentationUrl(currentProject);
          this.projectModel.view3dRepresentationForSavePurposes = new RepresentationVO();
          this.projectModel.view3dRepresentationForSavePurposes.data = objRepresentationData;
          this.projectModel.view3dRepresentationForSavePurposes.type = RepresentationVO.TYPE_VIEW3D;
          this.projectModel.view3dRepresentationForSavePurposes.url = representationUrl;
          currentProject.representations = [this.projectModel.view3dRepresentationForSavePurposes];
          ArticleContainerUtils.updateProjectWithGeometricData(currentProject, this.globalContainer);
          subject.next(undefined);
          subject.complete();
        },
        true,
        true,
        true,
        false,
        false,
        false,
        true
      );
      return subject;
    } else {
      currentProject.representations = [this.projectModel.view3dRepresentationForSavePurposes];
      ArticleContainerUtils.updateProjectWithGeometricData(currentProject, this.globalContainer);
      return of(null);
    }
  }


  public scheduleUpdateForCadExport(): Subject<any> {
    const currentProject: ProjectVO = this.projectModel.currentProject;
    if (!currentProject) {
      return new BehaviorSubject(null);
    }
    if (!this.projectModel.view3dRepresentationForCadExportPurposes) {
      const subject: Subject<any> = new Subject<any>();
      this.articleContainerUtils.scheduleCreateConfiguredObjRepresentationData(
        (objRepresentationData: OBJRepresentationDataVO): void => {
          const representationUrl: StringValueInLocalesVO = ProjectUtils.findFirstView3DRepresentationUrl(currentProject);
          this.projectModel.view3dRepresentationForCadExportPurposes = new RepresentationVO();
          this.projectModel.view3dRepresentationForCadExportPurposes.data = objRepresentationData;
          this.projectModel.view3dRepresentationForCadExportPurposes.type = RepresentationVO.TYPE_VIEW3D;
          this.projectModel.view3dRepresentationForCadExportPurposes.url = representationUrl;
          currentProject.representations = [this.projectModel.view3dRepresentationForCadExportPurposes];
          ArticleContainerUtils.updateProjectWithGeometricData(currentProject, this.globalContainer);
          subject.next(undefined);
        },
        false,
        false,
        true,
        false,
        false
      );
      return subject;
    } else {
      currentProject.representations = [this.projectModel.view3dRepresentationForCadExportPurposes];
      ArticleContainerUtils.updateProjectWithGeometricData(currentProject, this.globalContainer);
      return new BehaviorSubject(null);
    }
  }

}
